export const BiometricDeviceStatus = {
  ACTIVE: "active",
  INACTIVE: "inactive"
};

export const BiometricDeviceType = {
  FINGERPRINT: "fingerprint",
  FACE: "face"
};
